import React from 'react';
import { BzitVehicleDetails } from '../../../bzit';
import BzitLabel from '../../../bzit/BzitLabel';
import LocaleNumber from '../../../components/behavior/LocaleNumber';
import RegistrationDate from '../../../components/behavior/RegistrationDate';
import { Column, Row } from '../../../components/Grid';
import { HtmlContent } from '../../../components/layout/HtmlContent';
import { DetailHead, DetailPrice } from '../../../components/SearchDetail';
import { media } from '../../../theme/base/mixins';
import { Subtitle } from '../../../components/Subtitle';
import { Title, TitleProps } from '../../../components/Title';
import {
  withSearch,
  WithSearchProps
} from '../../../provider/SearchProvider/withSearch';
import Typo3Label from '../../../provider/Typo3Provider/Typo3Label';
import {
  withTypo3Translation,
  WithTypo3TranslationProps
} from '../../../provider/Typo3Provider/withTypo3Translation';
import { StyledHeadingComponent } from '../../../types';

interface SearchDetailPriceProps {
  vehicle: BzitVehicleDetails;
}

export const StyledTitleH1: StyledHeadingComponent<
  TitleProps
> = Title.H1.extend`
  font-size: ${(props) =>
    (props.theme.defaults.fontSize * props.theme.components.title.h2.size) /
    1.5}rem;
  font-weight: ${(props) =>
    props.theme.components.title.h2.fontWeight};
  font-style: ${(props) =>
    props.theme.components.title.h2.fontStyle};

  ${media.large`
  font-size: ${(props) =>
    props.theme.defaults.fontSize *
    props.theme.components.title.h2.size}rem;
  `};
` as any; // FIXME

export const SearchDetailPrice = ({ vehicle }: SearchDetailPriceProps) => (
  <DetailPrice>
    <StyledTitleH1 align="left">
      <LocaleNumber value={vehicle.price} /> {vehicle.currency}*
    </StyledTitleH1>

    <Subtitle.H2 className="tax" align="left">
      <Typo3Label label="searchItem.label.taxInfo" />
    </Subtitle.H2>
  </DetailPrice>
);

interface SearchDetailHeadProps {
  vehicle: BzitVehicleDetails;
}

const reformatLastUpdate = (date = '') => date.split(' ')[0];

const SearchDetailHead = ({
  search,
  typo3Translate,
  vehicle
}: SearchDetailHeadProps & WithTypo3TranslationProps & WithSearchProps) => (
  <DetailHead>
    <Row className="hide-for-print">
      <Column className="offer-info">
        <HtmlContent
          htmlString={typo3Translate('searchDetail.head.count').replace(
            '{x}',
            `<strong>${vehicle.countRequest}</strong>`
          )}
        />
        <br />
        <HtmlContent
          htmlString={typo3Translate('searchDetail.head.lastUpdate').replace(
            '{x}',
            `<strong>${reformatLastUpdate(
              search.searchParameters.lastUpdate
            )}</strong>`
          )}
        />
      </Column>
    </Row>
    <Row>
      <Column medium={12} large={8}>
        <StyledTitleH1 align="left" className="title">
          {vehicle.manufacturer} {vehicle.model}
        </StyledTitleH1>

        <Subtitle.H2 align="left" className="summary">
          <span>
            <BzitLabel label={vehicle.codeUsage} />
          </span>
          <span>
            <RegistrationDate date={vehicle.registration} />
          </span>
          <span>
            <LocaleNumber value={vehicle.milage} /> km
          </span>
        </Subtitle.H2>
      </Column>

      <Column large={4} showFor={'large'}>
        <SearchDetailPrice vehicle={vehicle} />
      </Column>
    </Row>
  </DetailHead>
);

const SearchDetailHeadEnhanced = withTypo3Translation(
  withSearch(SearchDetailHead)
);

export { SearchDetailHeadEnhanced as SearchDetailHead };
